export enum AccordionThemes {
  DEFAULT = 'default',
  DARK = 'dark',
  JOIN_FLOW = 'join-flow'
}
